'use es6';

import PropTypes from 'prop-types';
import PersonalizePopoverBodyInsertLegacy from './PersonalizePopoverBodyInsertLegacy';
import { useSettings } from './hooks/useSettings';
import { jsx as _jsx } from "react/jsx-runtime";
function PersonalizePopoverBodyInsert(props) {
  const {
    fetchSiteSettings
  } = props;
  const siteSettings = useSettings(fetchSiteSettings);
  return /*#__PURE__*/_jsx(PersonalizePopoverBodyInsertLegacy, Object.assign({
    siteSettings: siteSettings
  }, props));
}
PersonalizePopoverBodyInsert.propTypes = {
  fetchSiteSettings: PropTypes.func
};
PersonalizePopoverBodyInsert.displayName = 'PersonalizePopoverBodyInsert';
export default PersonalizePopoverBodyInsert;